export const UPDATE_UA_BIGQUERY_EVENT_PARAM_KEYS_NAME =
  "update_user_analytics_bigquery_event_param_keys" as const;

export const UPDATE_UA_BIGQUERY_EVENT_PARAM_KEYS_DESC = `Updates selected User Analytics BigQuery event parameter keys.

Use when the user wants to enable, change, or clear the event parameter keys materialized for User Analytics event-param filters.

Input:
- 'id' (required): UserAnalyticsBigQuery ID.
- 'selectedEventParamKeys' (required): Array of event parameter key strings. Pass [] to clear all selected keys. Maximum 10 unique non-empty keys.

Notes:
- Write operation (mutation via updateUserAnalyticsBigQueryEventParamKeys). Requires confirmation.
- The backend may normalize order and remove duplicates; the returned selectedEventParamKeys are authoritative.
- Updating keys can trigger event-param backfill. Check eventParamBackfill.status/progress in the result.`;
